/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import AuthService from 'cio/services/auth';
import HydraService from 'cio/services/hydra';
import AccountModel from 'cio/models/account';
import { Crumb } from 'cio/services/crumbs';
import AccountService from 'cio/services/account';
import { ProductApp } from 'cio/utils/product-app-info';

interface WorkspaceHeaderArgs {
  crumbs: Crumb[];
  showSupport: boolean;
  account: AccountModel;
  onCancelSupport: () => unknown;
  hidePageContentWhenChangingEnvironments: boolean;
}

export default class WorkspaceHeader extends Component<WorkspaceHeaderArgs> {
  @service account!: AccountService;
  @service auth!: AuthService;
  @service hydra!: HydraService;

  @action
  logout() {
    this.auth.logout(true);
  }

  get showBottomBorder() {
    if (this.hydra.useHydraTopNav) {
      return this.args.crumbs.length > 1;
    }

    return true;
  }

  get isJourneysActive() {
    return this.account.accessibleProducts.includes(ProductApp.JOURNEYS);
  }

  get showUpgradeLink(): boolean {
    return this.account?.current?.suspendTrialAt != null || this.account.planFeatures.messaging.expiresAt != null;
  }
}
